/**
 * Commerce › Prospection › Pistes (cadrage docs/COMMERCE-CADRAGE.md §6) : sollicitations entrantes (demande d'un client,
 * salon, site web, apporteur…) avant l'affaire. Une piste se qualifie, se rejette (motif) ou se CONVERTIT en affaire :
 * le client final est un tiers du référentiel (prospect compris, pas de conversion de compte), la source principale de
 * l'affaire reprend l'apporteur ou le canal de la piste, son besoin devient une ligne de besoin. Règles pures partagées.
 */
import type { STATUTS_AFFAIRE } from './affaires';

export const RESSOURCE_PISTES = 'commerce.prospection.pistes';

export const STATUTS_PISTE = ['nouvelle', 'qualification', 'convertie', 'rejetee'] as const;
export type StatutPiste = (typeof STATUTS_PISTE)[number];

/** Référence lisible : PIS-FR01-2026-0001 (numéro par filiale et par année). */
export const referencePiste = (filiale: string, annee: number, numero: number) => `PIS-${filiale}-${annee}-${String(numero).padStart(4, '0')}`;

/** Statuts de départ de chaque action (sinon 409). */
export const ACTIONS_PISTE = {
  qualifier: ['nouvelle'],
  rejeter: ['nouvelle', 'qualification'],
  convertir: ['nouvelle', 'qualification'],
  rouvrir: ['rejetee'],
} as const satisfies Record<string, readonly StatutPiste[]>;
export type ActionPiste = keyof typeof ACTIONS_PISTE;

export const actionPistePossible = (action: ActionPiste, statut: StatutPiste) => (ACTIONS_PISTE[action] as readonly StatutPiste[]).includes(statut);

/** Pistes à traiter (indicateur, filtre « à traiter ») : nouvelles ou en qualification. */
export const pisteATraiter = (statut: StatutPiste) => statut === 'nouvelle' || statut === 'qualification';

/** Affaire issue d'une piste convertie (lien de la fiche). */
export interface AffaireConvertie { id: string; reference: string; nom: string; statut: (typeof STATUTS_AFFAIRE)[number] }
